module.exports = __webpack_public_path__ + "media/images/interests/stress-cf0bf691636c108d54d3087d5932df07.png";